import { SkeletonData } from '@esotericsoftware/spine-threejs';
import { Asset } from '../types/damsel';
import Level from './Level';
import DamselFactory from './DamselFactory';

import { makeAutoObservable } from "mobx"
import ToolFactory, { Tool, ToolLocation } from './ToolFactory';
import Damsel from './Damsel';

type SkeletonDataMap = {
  [key in Asset]: SkeletonData
}

type InventoryItem = {
  tool: Tool,
  count: number
}
type Inventory = InventoryItem[]

export default class Game {

  public levels: Level[] = []
  private skeletonDataMap: SkeletonDataMap
  public levelIndex = 0
  private damselFactory: DamselFactory
  private toolFactory: ToolFactory
  public toolList: Tool[]
  private inventory: Inventory = []
  public heldTool: Tool | null = null

  public money = 100

  constructor(skeletonDataMap: SkeletonDataMap) {
    this.skeletonDataMap = skeletonDataMap
    this.damselFactory = new DamselFactory(this.skeletonDataMap['damsel'])
    this.toolFactory = new ToolFactory(this.skeletonDataMap['tools'])
    this.toolList = this.toolFactory.getTools()
    this.initLevels()
    makeAutoObservable(this)
  }

  private initLevels() {
    const l1 = new Level()
    const l2 = new Level()
    l1.addDamsel(this.damselFactory.create('heather', { bra: 'bra1', underwear: 'underwear1' }))
    l2.addDamsel(this.damselFactory.create('liana', null, { position: -110 }))
    this.levels.push(l1, l2)
  }

  public getCurrentLevel() {
    return this.levels[this.levelIndex]
  }

  public getLevel(index: number) {
    if(this.levels[index]) {
      return this.levels[index]
    }
    throw new Error('No such level')
  }
  public setLevel(index: number) {
    this.levelIndex = index
  }

  public getLevels() {
    return this.levels
  }

  public getLevelNumber() {
    return this.levelIndex + 1
  }

  public getBalance() {
    return this.money
  }
  public spend(amountToSpend: number) {
    if(amountToSpend <= this.money) {
      this.money -= amountToSpend
      return true
    } else {
      return false
    }
  }

  private addToInventory(tool: Tool) {
    let added = false

    for(let i=0; i < this.inventory.length; i++) {
      if(this.inventory[i].tool.name === tool.name) {
        this.inventory[i].count++
        added = true
      }
    }
    if(!added) {
      this.inventory.push({
        count: 1,
        tool: tool
      })
    } 
  }
  private removeFromInventory(tool: Tool) {
    let removed = false
    for(let i=0; i < this.inventory.length; i++) {
      if(this.inventory[i].tool.name === tool.name) {
        this.inventory[i].count--
        removed = true
      }
    }
    if(removed) {
      this.inventory = this.inventory.filter(i => i.count !== 0)
      return tool
    }
    return null
  }

  public setHeldItem(tool: Tool) {
    this.removeHeldItem(true)
    this.heldTool = this.removeFromInventory(tool)
  }
  public removeHeldItem(addBackToInventory = false) {
    if(this.heldTool && addBackToInventory){
      this.addToInventory(this.heldTool)
    }
    this.heldTool = null
  }

  public getHeldTool() {
    if(!this.heldTool) {
      return null
    }
    return this.toolFactory.getMesh(this.heldTool)
  }

  public buyItem(tool: Tool) {
    if(this.spend(tool.cost)) {
      this.addToInventory(tool)
      return true
    }
    return false
  }

  public getInventory() {
    return this.inventory
  }

  public updateTool(damsel: Damsel, location: ToolLocation) {
    let updatedTool: Tool | null | false;
    if(this.heldTool) {
      updatedTool = damsel.equipTool(this.heldTool, location)
    } else {
      updatedTool = damsel.unEquipTool(location)
    }
    if(updatedTool || updatedTool === null) {
      console.log('held tool updated', updatedTool)
      this.heldTool = updatedTool
    }
  }



  


}